import React from 'react'
import { Tabs, Tab, Box } from '@mui/material'
import styled from '@emotion/styled'

const CustomTabLabel = styled(Tab)({
  textTransform: 'capitalize',
  minWidth: '100px',
  marginRight: '16px',
  color: '#7D7D7D',
  padding: '1.2px',
  backgroundColor: 'rgba(43, 36, 96, 0.05) !important',
  backgroundImage:
    'linear-gradient(180deg,  rgba(54, 95, 145, 0.2), rgba(54, 95, 145, 0.1) 100%)',
  borderRadius: '57px',
  backdropFilter: 'blur(18px)',
  webkitBackdropFilter: 'blur(18px)',
  '&:hover': {
    color: '#7D7D7D',
    backgroundColor: 'transparent',
  },
  '&.Mui-selected': {
    color: 'white',
    borderTop: 'none !important',
    borderRadius: '57px  !important',
    backgroundColor: '#FB5012 !important',
    backgroundImage: 'none !important',
    WebkitMask: 'none',
    WebkitMaskComposite: 'none ',
  },
  '@media (max-width: 768px)': {
    minWidth: '60px',
    marginRight: '8px',
    fontSize: '13px',
  },
})

const CustomTabPanel = (props: {
  children?: React.ReactNode
  value: number
  index: number
}) => {
  const { children, value, index, ...other } = props

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`custom-tabpanel-${index}`}
      aria-labelledby={`custom-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: { xs: 1, md: 3 } }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  )
}

const CustomTabs = ({
  tabs,
  value,
  onChange,
}: {
  tabs: { label: string; content: React.ReactNode }[]
  value: number
  onChange: (event: React.SyntheticEvent, newValue: number) => void
}) => {
  return (
    <Box sx={{ maxWidth: '100%' }}>
      <Tabs
        value={value}
        onChange={onChange}
        variant="scrollable"
        scrollButtons={false}
        aria-label="dynamic tabs"
        TabIndicatorProps={{ sx: { display: 'none' } }}
      >
        {tabs.map((tab, index) => (
          <CustomTabLabel
            key={index}
            label={<div className="px-3 py-2 md:px-6 md:py-4">{tab.label}</div>}
            id={`custom-tab-${index}`}
            aria-controls={`custom-tabpanel-${index}`}
            className="bg-grad before:rounded-[57px] before:!border-[1.6px]"
          />
        ))}
      </Tabs>

      {tabs.map((tab, index) => (
        <CustomTabPanel key={index} value={value} index={index}>
          {tab.content}
        </CustomTabPanel>
      ))}
    </Box>
  )
}

export default CustomTabs
